/* ==========================================================================
   Perro Collection — Size Finder Embed (PDP drawer, v1)
   Loaded by: snippets/size-chart-content.liquid
   Scoped per container: werkt met meerdere drawers per pagina
   (variant-picker drawer + add-to-cart-confirmatiemodal) en overleeft
   section re-renders via lazy init bij het openen van de drawer.

   Randen-playbook (aug 2026, n.a.v. maatschema-audit): overlap -> grootste
   maat, micro-gat (<=1 cm) -> grootste buurmaat, echt gat/buiten bereik ->
   contact (chat), borst beslist bij 2 metingen, hals is controle.

   LET OP: de maatdata hieronder is een kopie van de data in de
   size-finder page builds (size-finder*.js). Wijzigt een maatrange,
   pas dan beide aan.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__PerroSFEmbed) return;
  window.__PerroSFEmbed = true;

  /* ---------- Maatdata (bron: size-finder page builds) ---------- */
  var DATA = {
    'collar': {
      diagram: true,
      measurements: [{ key: 'neck' }],
      sizes: [
        { size: '25', neck: [15, 17] },
        { size: '30', neck: [18, 23] },
        { size: '35', neck: [23, 29] },
        { size: '40', neck: [30, 33] },
        { size: '45', neck: [33, 38] },
        { size: '55', neck: [41, 50] }
      ]
    },
    'step-in': {
      diagram: true,
      measurements: [{ key: 'chest' }],
      sizes: [
        { size: 'XXS', chest: [25, 27] },
        { size: 'XS',  chest: [29, 34] },
        { size: 'S',   chest: [35, 39] },
        { size: 'M',   chest: [40, 43] },
        { size: 'L',   chest: [43, 49] },
        { size: 'L/XL',chest: [49, 52] },
        { size: 'XL',  chest: [53, 62] },
        { size: 'XXL', chest: [63, 69] }
      ]
    },
    'h-harness': {
      diagram: true,
      primary: 'chest',
      measurements: [{ key: 'neck' }, { key: 'chest' }],
      sizes: [
        { size: 'XXS', neck: [19, 23], chest: [27, 32] },
        { size: 'XS',  neck: [24, 30], chest: [37, 43] },
        { size: 'S',   neck: [27, 33], chest: [42, 48] },
        { size: 'M',   neck: [30, 36], chest: [45, 51] },
        { size: 'L',   neck: [33, 39], chest: [50, 56] },
        { size: 'XL',  neck: [36, 42], chest: [55, 61] },
        { size: 'XXL', neck: [36, 41], chest: [58, 62] }
      ]
    },

    'sweater': {
      diagram: true,
      primary: 'chest',
      measurements: [{ key: 'chest' }, { key: 'neck' }],
      sizes: [
        { size: 'XS', chest: [25, 28], neck: [15, 18] },
        { size: 'S',  chest: [29, 34], neck: [18, 22] },
        { size: 'M',  chest: [35, 38], neck: [22, 25] },
        { size: 'L',  chest: [39, 45], neck: [25, 27] }
      ]
    },

    'leash': { leashFlow: true }
  };

  /* ---------- UI-teksten per taal ---------- */
  var I18N = {
    en: {
      neck: 'Neck circumference', chest: 'Chest circumference',
      neckTip: 'Measure where the collar naturally sits, snug with no extra space.',
      chestTip: 'Measure right behind the armpits all around.',
      empty: 'Enter the measurement to see your size',
      addMore: 'Add 1 more measurement',
      yourSize: 'Your size',
      confHigh: 'Perfect match', confGood: 'Great fit',
      confLow: 'Recommended next size up',
      confNone: 'Outside our standard range, please contact us',
      confSplit: 'Between two sizes, we recommend the larger',
      widthChoose: 'Choose your leather width',
      select: 'Select size {s}',
      selected: 'Size {s} selected',
      pers: 'Free personalization with one initial. Personalized items are exchangeable for size only.',
      chatHint: 'Use the chat at the bottom right \u2192',
      groups: { 'collar': 'Collar', 'step-in': 'Step-in Harness', 'h-harness': 'H-Harness', 'leash': 'Leash', 'sweater': 'Sweater' },
      lengthChoose: 'Choose your length',
      leashEyebrow: 'Your leash',
      pairs: 'Pairs with your {s} cm collar or harness',
      dec: '.'
    },
    nl: {
      neck: 'Halsomvang', chest: 'Borstomvang',
      neckTip: 'Meet om de hals, waar de halsband natuurlijk valt. Strak, zonder extra ruimte.',
      chestTip: 'Meet rondom, direct achter de oksels.',
      empty: 'Vul de meting in en zie direct jouw maat',
      addMore: 'Voeg nog 1 meting toe',
      yourSize: 'Jouw maat',
      confHigh: 'Perfecte match', confGood: 'Goede pasvorm',
      confLow: 'Wij adviseren een maat groter',
      confNone: 'Buiten ons standaard bereik, neem contact met ons op',
      confSplit: 'Tussen twee maten, wij adviseren de grootste',
      widthChoose: 'Kies je leerbreedte',
      select: 'Selecteer maat {s}',
      selected: 'Maat {s} geselecteerd',
      pers: 'Gratis personalisatie met initiaal. Gepersonaliseerde items alleen maatruil.',
      chatHint: 'Gebruik de chat rechtsonder \u2192',
      groups: { 'collar': 'Halsband', 'step-in': 'Step-in Harnas', 'h-harness': 'H-Harnas', 'leash': 'Riem', 'sweater': 'Sweater' },
      lengthChoose: 'Kies je lengte',
      leashEyebrow: 'Jouw riem',
      pairs: 'Past bij je {s} cm halsband of harnas',
      dec: ','
    },
    de: {
      neck: 'Halsumfang', chest: 'Brustumfang',
      neckTip: 'Miss dort, wo das Halsband natürlich sitzt. Eng anliegend, ohne Spielraum.',
      chestTip: 'Miss rundherum, direkt hinter den Achseln.',
      empty: 'Gib die Messung ein und sieh sofort deine Größe',
      addMore: 'Füge noch 1 Messung hinzu',
      yourSize: 'Deine Größe',
      confHigh: 'Perfekte Passform', confGood: 'Gute Passform',
      confLow: 'Wir empfehlen eine Größe größer',
      confNone: 'Außerhalb unseres Standardbereichs, kontaktiere uns',
      confSplit: 'Zwischen zwei Größen, wir empfehlen die größere',
      widthChoose: 'Wähle deine Lederbreite',
      select: 'Größe {s} wählen',
      selected: 'Größe {s} gewählt',
      pers: 'Kostenlose Personalisierung mit Initiale. Personalisierte Artikel nur Größentausch.',
      chatHint: 'Nutze den Chat unten rechts \u2192',
      groups: { 'collar': 'Halsband', 'step-in': 'Step-in-Geschirr', 'h-harness': 'H-Geschirr', 'leash': 'Leine', 'sweater': 'Pullover' },
      lengthChoose: 'Wähle deine Länge',
      leashEyebrow: 'Deine Leine',
      pairs: 'Passend zu deinem {s} cm Halsband oder Geschirr',
      dec: ','
    },
    it: {
      neck: 'Circonferenza del collo', chest: 'Circonferenza del torace',
      neckTip: 'Misura dove il collare appoggia naturalmente, aderente e senza gioco.',
      chestTip: "Misura tutt'intorno, appena dietro le ascelle.",
      empty: 'Inserisci la misura e scopri subito la taglia',
      addMore: 'Aggiungi ancora 1 misura',
      yourSize: 'La tua taglia',
      confHigh: 'Vestibilità perfetta', confGood: 'Ottima vestibilità',
      confLow: 'Consigliata: una taglia in più',
      confNone: 'Fuori dalla nostra gamma standard, contattaci',
      confSplit: 'Tra due taglie, consigliamo la più grande',
      widthChoose: 'Scegli la larghezza della pelle',
      select: 'Seleziona la taglia {s}',
      selected: 'Taglia {s} selezionata',
      pers: 'Personalizzazione gratuita con iniziale. Articoli personalizzati solo cambio taglia.',
      chatHint: 'Usa la chat in basso a destra \u2192',
      groups: { 'collar': 'Collare', 'step-in': 'Pettorina Step-in', 'h-harness': 'Pettorina ad H', 'leash': 'Guinzaglio', 'sweater': 'Maglione' },
      lengthChoose: 'Scegli la lunghezza',
      leashEyebrow: 'Il tuo guinzaglio',
      pairs: 'Si abbina al tuo collare o pettorina da {s} cm',
      dec: ','
    },
    es: {
      neck: 'Contorno del cuello', chest: 'Contorno del pecho',
      neckTip: 'Mide donde el collar se apoya de forma natural, ajustado y sin holgura.',
      chestTip: 'Mide alrededor del pecho, justo detrás de las axilas.',
      empty: 'Introduce la medida y descubre tu talla al instante',
      addMore: 'Añade 1 medida más',
      yourSize: 'Tu talla',
      confHigh: 'Ajuste perfecto', confGood: 'Muy buen ajuste',
      confLow: 'Te recomendamos una talla más',
      confNone: 'Fuera de nuestro rango estándar, contáctanos',
      confSplit: 'Entre dos tallas, te recomendamos la mayor',
      widthChoose: 'Elige el ancho de la piel',
      select: 'Seleccionar talla {s}',
      selected: 'Talla {s} seleccionada',
      pers: 'Personalización gratuita con una inicial. Los artículos personalizados solo admiten cambio de talla.',
      chatHint: 'Usa el chat abajo a la derecha \u2192',
      groups: { 'collar': 'Collar', 'step-in': 'Arnés Step-in', 'h-harness': 'Arnés en H', 'leash': 'Correa', 'sweater': 'Jersey' },
      lengthChoose: 'Elige la longitud',
      leashEyebrow: 'Tu correa',
      pairs: 'Combina con tu collar o arnés de {s} cm',
      dec: ','
    }
  };

  function track(name, params) {
    try {
      window.dataLayer = window.dataLayer || [];
      var payload = { event: name };
      for (var k in params) { payload[k] = params[k]; }
      window.dataLayer.push(payload);
      if (typeof window.gtag === 'function') { window.gtag('event', name, params); }
    } catch (err) { /* tracking mag nooit de UX raken */ }
  }

  function deepFindButton(root) {
    // Recursief door light DOM en alle shadow roots binnen een chat-host
    var stack = [root];
    var guard = 0;
    while (stack.length && guard++ < 400) {
      var node = stack.pop();
      var scope = node.shadowRoot || node;
      if (scope.querySelector) {
        var btn = scope.querySelector('button, [role="button"]');
        if (btn) return btn;
        var kids = scope.querySelectorAll('*');
        for (var i = 0; i < kids.length && i < 250; i++) {
          if (kids[i].shadowRoot) stack.push(kids[i]);
        }
      }
    }
    return null;
  }

  function openStoreChat() {
    var sels = ['#chat-button-container', 'shopify-chat', '#shopify-chat', '#ShopifyChat', '.shopify-chat', '[id*="shopify-chat" i]', '[id*="chat-button" i]'];
    for (var i = 0; i < sels.length; i++) {
      var hosts = document.querySelectorAll(sels[i]);
      for (var j = 0; j < hosts.length; j++) {
        var btn = deepFindButton(hosts[j]);
        if (btn) { btn.click(); return true; }
      }
    }
    return false;
  }

  function parseNum(raw) { return parseFloat(String(raw).replace(',', '.')); }
  function esc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function fmt(tpl, s) { return tpl.replace('{s}', s); }
  function shortLabel(text) {
    // Set-waarden ('Harness S-1.5 - Leash S - Poopbag holder') inkorten
    // tot het maatgevende deel; gewone waarden blijven ongemoeid.
    if (text.indexOf(' - ') > -1 && text.length > 18) return text.split(' - ')[0].trim();
    return text;
  }

  /* ---------- Variant-koppeling: lees echte maten van de PDP ---------- */

  function findSizeInputs(root) {
    // De variant-picker drawer zit in dezelfde fieldset als de size-optie
    // 1) Drawer in de size-fieldset zelf; 2) sectie; 3) paginabreed
    //    (vangt ook drawers die het theme naar body verplaatst)
    var fs = root.closest('fieldset');
    var scope = fs;
    var inputs = fs ? fs.querySelectorAll('input[type="radio"][data-option-position]') : [];
    if (!inputs.length) {
      scope = root.closest('.shopify-section') || document;
      inputs = scope.querySelectorAll('variant-picker input[type="radio"][data-option-position]');
    }
    if (!inputs.length && scope !== document) {
      scope = document;
      inputs = document.querySelectorAll('variant-picker input[type="radio"][data-option-position]');
    }
    if (!inputs.length) return [];
    var out = [];
    var seen = {};
    inputs.forEach(function (input) {
      if (input.disabled) return;
      // Block-selector: input en label zijn siblings, gekoppeld via for/id.
      // Dropdown-selector (o.a. Pink-template): input zit IN het label.
      var label = null;
      if (input.id) {
        try { label = scope.querySelector('label[for="' + input.id.replace(/"/g, '\\"') + '"]'); } catch (err) { label = null; }
      }
      if (!label) label = input.closest('label');
      var text = label ? label.textContent.replace(/\s+/g, ' ').trim() : '';
      if (text && !seen[text]) { seen[text] = true; out.push({ input: input, text: text }); }
    });
    return out;
  }

  function matchVariants(size, entries) {
    // Matcht 'S' op: 'S', 'S-1.5', 'S-2', en set-waarden 'Harness S-1.5 - ...'
    var re = new RegExp('(^|harness\\s)' + esc(size) + '($|[\\s\\-])', 'i');
    return entries.filter(function (e) { return re.test(e.text); });
  }

  /* ---------- Render ---------- */

  function build(root) {
    if (root.dataset.sfInit) return;
    root.dataset.sfInit = '1';

    var group = root.getAttribute('data-group');
    var lang = root.getAttribute('data-lang') || 'en';
    var data = DATA[group];
    var t = I18N[lang] || I18N.en;
    if (!data) return;

    if (data.leashFlow) { buildLeash(root, t, group); return; }

    var values = {};
    var showPers = group === 'collar' || group === 'step-in' || group === 'h-harness';

    root.innerHTML =
      '<div class="sfe-title">' + ((t.groups && t.groups[group]) || '') + '</div>' +
      (data.diagram ? '<img class="sfe-diagram" src="https://cdn.shopify.com/s/files/1/0578/7500/5499/files/dog-measurement-transparent.png?v=1779661358" alt="" width="140" height="140" loading="lazy">' : '') +
      '<div class="sfe-fields"></div>' +
      '<div class="sfe-toggle" role="radiogroup">' +
        '<button type="button" class="sfe-unit is-on" data-unit="cm">CM</button>' +
        '<button type="button" class="sfe-unit" data-unit="in">INCH</button>' +
      '</div>' +
      '<div class="sfe-result sfe-result--empty">' + t.empty + '</div>' +
      (showPers ? '<div class="sfe-pers">' + t.pers + '</div>' : '');

    var fieldsEl = root.querySelector('.sfe-fields');
    var resultEl = root.querySelector('.sfe-result');
    var unit = 'cm';

    function placeholder(key) {
      var ex = key === 'neck' ? (unit === 'cm' ? '32' : '12.6') : (unit === 'cm' ? '45' : '17.7');
      return t.dec === ',' ? ex.replace('.', ',') : ex;
    }

    function renderFields() {
      fieldsEl.innerHTML = '';
      data.measurements.forEach(function (m) {
        var wrap = document.createElement('div');
        wrap.className = 'sfe-field';
        wrap.innerHTML =
          '<label class="sfe-label">' +
            '<span><span class="sfe-ab">' + (m.key === 'neck' ? 'A' : 'B') + '</span>' + t[m.key] + '</span>' +
          '</label>' +
          '<div class="sfe-inputwrap">' +
            '<input type="text" inputmode="decimal" autocomplete="off" class="sfe-input" data-key="' + m.key + '" placeholder="' + placeholder(m.key) + '">' +
            '<span class="sfe-suffix">' + (unit === 'in' ? 'in' : 'cm') + '</span>' +
          '</div>' +
          '<div class="sfe-hint">' + t[m.key + 'Tip'] + '</div>';
        fieldsEl.appendChild(wrap);

        var input = wrap.querySelector('input');
        if (values[m.key] != null) {
          var v = unit === 'cm' ? values[m.key] : (values[m.key] / 2.54).toFixed(1);
          input.value = t.dec === ',' ? String(v).replace('.', ',') : String(v);
        }
        input.addEventListener('input', function (e) {
          var val = parseNum(e.target.value);
          if (isNaN(val) || val <= 0) { delete values[m.key]; }
          else { values[m.key] = unit === 'cm' ? val : val * 2.54; }
          calc();
        });
      });
    }

    root.querySelectorAll('.sfe-unit').forEach(function (btn) {
      btn.addEventListener('click', function () {
        unit = btn.getAttribute('data-unit');
        root.querySelectorAll('.sfe-unit').forEach(function (b) {
          b.classList.toggle('is-on', b === btn);
        });
        renderFields();
        calc();
      });
    });

    function locate(key, v) {
      // Randen-playbook (audit aug 2026): overlap -> grootste maat,
      // micro-gat (<= 1 cm tussen ranges) -> grootste buurmaat,
      // echt gat of buiten bereik -> contact.
      var ranged = [];
      data.sizes.forEach(function (s, i) { if (s[key]) ranged.push({ i: i, r: s[key] }); });
      var hit = -1, hitCount = 0;
      ranged.forEach(function (x) { if (v >= x.r[0] && v <= x.r[1]) { hit = x.i; hitCount++; } });
      if (hit > -1) return { t: 'hit', i: hit, multi: hitCount > 1 };
      if (v < ranged[0].r[0] || v > ranged[ranged.length - 1].r[1]) return { t: 'none' };
      for (var j = 0; j < ranged.length - 1; j++) {
        var cur = ranged[j], nxt = ranged[j + 1];
        if (v > cur.r[1] && v < nxt.r[0]) {
          return (nxt.r[0] - cur.r[1] <= 1) ? { t: 'snap', i: nxt.i } : { t: 'none' };
        }
      }
      return { t: 'none' };
    }

    function calc() {
      var req = data.measurements.map(function (m) { return m.key; });
      var have = req.filter(function (k) { return values[k] != null && values[k] > 0; });

      if (have.length < req.length) {
        resultEl.className = 'sfe-result sfe-result--empty';
        resultEl.textContent = have.length === 0 ? t.empty : t.addMore;
        return;
      }

      // Primaire meting beslist (borst bij tuig en sweater); de tweede
      // meting is controle: 1 maat hoger -> maat groter, verder uiteen
      // of buiten bereik -> contact met een mens.
      var primary = data.primary || req[0];
      var pLoc = locate(primary, values[primary]);
      var result = null, conf;

      if (pLoc.t !== 'none') {
        var idx = pLoc.i;
        conf = pLoc.t === 'snap' ? 'split' : (pLoc.multi ? 'good' : 'high');
        for (var q = 0; q < req.length; q++) {
          var sec = req[q];
          if (sec === primary) continue;
          var sLoc = locate(sec, values[sec]);
          if (sLoc.t === 'none') { conf = 'none'; break; }
          var sr = data.sizes[idx][sec];
          var inRange = sr && values[sec] >= sr[0] && values[sec] <= sr[1];
          if (!inRange) {
            if (sLoc.i === idx + 1) { idx = sLoc.i; conf = 'split'; }
            else if (sLoc.i > idx + 1) { conf = 'none'; break; }
            else if (conf === 'high') { conf = 'good'; }
          }
        }
        if (conf !== 'none') result = data.sizes[idx];
      }

      if (!result) {
        // Toon de dichtstbijzijnde maat als context; advies = contact.
        var scored = data.sizes.map(function (s) {
          var d = 0;
          req.forEach(function (k) {
            var r = s[k], v = values[k];
            if (!r) return;
            if (v < r[0]) d += r[0] - v;
            else if (v > r[1]) d += v - r[1];
          });
          return { s: s, d: d };
        }).sort(function (a, b) { return a.d - b.d; });
        result = scored[0].s;
        conf = 'none';
      }
      showResult(result, conf);
    }

    var lastTracked = '';
    function showResult(sizeObj, conf) {
      if (sizeObj.size !== lastTracked) {
        lastTracked = sizeObj.size;
        track('perro_size_finder_result', { size_group: group, size: sizeObj.size, confidence: conf });
      }
      var confLabel = conf === 'high' ? t.confHigh : conf === 'good' ? t.confGood : conf === 'split' ? t.confSplit : conf === 'low' ? t.confLow : t.confNone;
      var confOk = conf === 'high' || conf === 'good' || conf === 'split';
      var confWarn = conf === 'low' || conf === 'none';
      if (confOk) { confLabel = '\u2713 ' + confLabel; }
      if (conf === 'none') {
        confLabel = '<a href="mailto:info@perrocollection.com" class="sfe-conf-link">' + confLabel + '</a>';
      }

      var ranges = data.measurements.map(function (m) {
        var r = sizeObj[m.key];
        return r ? t[m.key] + ' ' + r[0] + '–' + r[1] + ' cm' : '';
      }).filter(Boolean).join(' · ');

      resultEl.className = 'sfe-result';
      resultEl.innerHTML =
        '<div class="sfe-eyebrow">' + t.yourSize + '</div>' +
        '<div class="sfe-size">' + sizeObj.size + '</div>' +
        '<div class="sfe-conf' + (confOk ? ' sfe-conf--ok' : '') + (confWarn ? ' sfe-conf--warn' : '') + '">' + confLabel + '</div>' +
        '<div class="sfe-range">' + ranges + '</div>' +
        '<div class="sfe-actions"></div>';

      var confLink = resultEl.querySelector('.sfe-conf-link');
      if (confLink) {
        confLink.addEventListener('click', function (e) {
          // Drawer sluiten zodat de chat zichtbaar is, dan Inbox openen; mailto als vangnet
          var drawer = root.closest('x-drawer');
          if (drawer && drawer.id) {
            var trigger = document.querySelector('[aria-controls="' + drawer.id + '"][aria-expanded="true"]');
            if (trigger) { trigger.click(); }
            else if (typeof drawer.hide === 'function') { drawer.hide(); }
          }
          if (openStoreChat()) {
            e.preventDefault();
            track('perro_size_finder_chat', { size_group: group, method: 'widget' });
          }
          // knop onvindbaar -> <a href="mailto:..."> als stil vangnet
        });
      }

      var actions = resultEl.querySelector('.sfe-actions');
      if (conf === 'none') return; // buiten bereik of gat: niets selecteren, contact is het advies
      var entries = findSizeInputs(root);
      var matches = matchVariants(sizeObj.size, entries);

      if (matches.length === 0) return;

      if (matches.length === 1) {
        addCta(actions, matches[0]);
      } else {
        var lbl = document.createElement('div');
        lbl.className = 'sfe-widthlabel';
        lbl.textContent = t.widthChoose;
        actions.appendChild(lbl);

        var row = document.createElement('div');
        row.className = 'sfe-widthrow';
        actions.appendChild(row);

        var chosen = matches[matches.length - 1];
        matches.forEach(function (m) {
          var card = document.createElement('button');
          card.type = 'button';
          card.className = 'sfe-wcard' + (m === chosen ? ' is-sel' : '');
          card.textContent = shortLabel(m.text);
          card.addEventListener('click', function () {
            chosen = m;
            row.querySelectorAll('.sfe-wcard').forEach(function (c) { c.classList.toggle('is-sel', c === card); });
            cta.textContent = fmt(t.select, shortLabel(m.text));
          });
          row.appendChild(card);
        });

        var cta = addCta(actions, null);
        cta.textContent = fmt(t.select, shortLabel(chosen.text));
        cta.addEventListener('click', function () { pick(chosen, cta); });
        return;
      }

      function addCta(parent, entry) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'sfe-cta';
        if (entry) {
          b.textContent = fmt(t.select, shortLabel(entry.text));
          b.addEventListener('click', function () { pick(entry, b); });
        }
        parent.appendChild(b);
        return b;
      }

      function pick(entry, btn) {
        entry.input.click();
        entry.input.dispatchEvent(new Event('change', { bubbles: true }));
        root.dispatchEvent(new CustomEvent('perro:sizefinder:selected', { bubbles: true, detail: { size: entry.text, group: group } }));

        if (btn) {
          btn.textContent = '\u2713 ' + fmt(t.selected, shortLabel(entry.text));
          btn.disabled = true;
        }

        track('perro_size_finder_select', { size_group: group, size: shortLabel(entry.text) });

        setTimeout(function () {
          var drawer = root.closest('x-drawer');
          if (drawer && drawer.id) {
            var trigger = document.querySelector('[aria-controls="' + drawer.id + '"][aria-expanded="true"]');
            if (trigger) { trigger.click(); }
            else if (typeof drawer.hide === 'function') { drawer.hide(); }
          }
          if (btn) { btn.disabled = false; }

          // Volgende stap begeleiden: scroll naar personalisatie (verplicht veld)
          // of anders de koopzone, met een subtiele highlight.
          var section = root.closest('.shopify-section') || document;
          var target = section.querySelector('select[name^="properties["], input[name^="properties["]');
          var zone = target ? target.closest('div') : section.querySelector('product-form');
          if (zone && typeof zone.scrollIntoView === 'function') {
            zone.scrollIntoView({ behavior: 'smooth', block: 'center' });
            zone.classList.add('sfe-guide-highlight');
            setTimeout(function () { zone.classList.remove('sfe-guide-highlight'); }, 1800);
          }
        }, 700);
      }
    }

    renderFields();
    root.dispatchEvent(new CustomEvent('perro:sizefinder:open', { bubbles: true, detail: { group: group } }));
  }

  function buildLeash(root, t, group) {
    var w = null, l = null;

    root.innerHTML =
      '<div class="sfe-title">' + ((t.groups && t.groups[group]) || '') + '</div>' +
      '<div class="sfe-widthlabel">' + t.widthChoose + '</div>' +
      '<div class="sfe-widthrow" data-q="w">' +
        '<button type="button" class="sfe-wcard" data-v="1.5"><span>1,5 cm</span></button>' +
        '<button type="button" class="sfe-wcard" data-v="2"><span>2 cm</span></button>' +
      '</div>' +
      '<div class="sfe-widthlabel">' + t.lengthChoose + '</div>' +
      '<div class="sfe-widthrow" data-q="l">' +
        '<button type="button" class="sfe-wcard" data-v="Short"><span>Short</span><small class="sfe-wsub">130 cm</small></button>' +
        '<button type="button" class="sfe-wcard" data-v="Long"><span>Long</span><small class="sfe-wsub" data-longsub>245 / 235 cm</small></button>' +
      '</div>' +
      '<div class="sfe-result sfe-result--empty">' + t.empty + '</div>';

    var resultEl = root.querySelector('.sfe-result');

    root.querySelectorAll('.sfe-widthrow[data-q] .sfe-wcard').forEach(function (card) {
      card.addEventListener('click', function () {
        var q = card.closest('.sfe-widthrow').getAttribute('data-q');
        if (q === 'w') { w = card.getAttribute('data-v'); }
        else { l = card.getAttribute('data-v'); }
        card.closest('.sfe-widthrow').querySelectorAll('.sfe-wcard').forEach(function (c) {
          c.classList.toggle('is-sel', c === card);
        });
        var longsub = root.querySelector('[data-longsub]');
        if (longsub && w) { longsub.textContent = (w === '1.5' ? '245' : '235') + ' cm'; }
        renderLeashResult();
      });
    });

    function renderLeashResult() {
      if (!w || !l) {
        resultEl.className = 'sfe-result sfe-result--empty';
        resultEl.textContent = t.empty;
        return;
      }
      var type = l + ' ' + (w === '1.5' ? 'S' : 'M');
      var wLabel = w === '1.5' ? '1,5' : '2';
      track('perro_size_finder_result', { size_group: group, size: type, confidence: 'high' });

      resultEl.className = 'sfe-result';
      resultEl.innerHTML =
        '<div class="sfe-eyebrow">' + t.leashEyebrow + '</div>' +
        '<div class="sfe-size">' + type + '</div>' +
        '<div class="sfe-conf sfe-conf--ok">\u2713 ' + fmt(t.pairs, wLabel) + '</div>' +
        '<div class="sfe-actions"></div>';

      var actions = resultEl.querySelector('.sfe-actions');
      var entries = findSizeInputs(root);
      var matches = matchVariants(type, entries);
      if (!matches.length) {
        // Perro-waardenotatie: 'Short leash 130-1.5CM' / 'Long leash 235-2CM'
        matches = entries.filter(function (e) {
          var txt = e.text.toUpperCase();
          if (txt.indexOf(l.toUpperCase()) === -1) return false;
          var has15 = /1[.,]5/.test(txt);
          return w === '1.5' ? has15 : !has15;
        });
      }
      if (!matches.length) return;
      var entry = matches[0];
      var display = entry.text.replace(/\s*leash\s*/i, ' ').replace(/\s+/g, ' ').trim();
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'sfe-cta';
      b.textContent = fmt(t.select, shortLabel(display));
      b.addEventListener('click', function () {
        entry.input.click();
        entry.input.dispatchEvent(new Event('change', { bubbles: true }));
        track('perro_size_finder_select', { size_group: group, size: shortLabel(display) });
        b.textContent = '\u2713 ' + fmt(t.selected, shortLabel(display));
        b.disabled = true;
        setTimeout(function () {
          var drawer = root.closest('x-drawer');
          if (drawer && drawer.id) {
            var trigger = document.querySelector('[aria-controls="' + drawer.id + '"][aria-expanded="true"]');
            if (trigger) { trigger.click(); }
            else if (typeof drawer.hide === 'function') { drawer.hide(); }
          }
          b.disabled = false;
        }, 700);
      });
      actions.appendChild(b);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-perro-size-embed]:not([data-sf-init])').forEach(build);
  }

  // Init direct (containers staan al in de DOM bij defer) en nogmaals op
  // DOMContentLoaded; de per-container guard voorkomt dubbele opbouw.
  initAll();
  document.addEventListener('DOMContentLoaded', initAll);

  // Lazy re-init: drawers kunnen opnieuw gerenderd worden na variant-wissel
  document.addEventListener('click', function (e) {
    var trg = e.target.closest('[aria-controls^="size-chart-"]');
    if (!trg) return;
    setTimeout(initAll, 60);
    if (trg.getAttribute('aria-expanded') !== 'true') {
      var dr = document.getElementById(trg.getAttribute('aria-controls'));
      var emb = dr && dr.querySelector('[data-perro-size-embed]');
      track('perro_size_finder_open', { size_group: emb ? emb.getAttribute('data-group') : '' });
    }
  });
})();
